import { PhoneNumberUtil } from 'google-libphonenumber'

const COUNTRY_TO_REGIONS: Record<string, string> = {
  uk: 'gb',
}

export function normalizeAndFormatPhoneNumber({
  phoneNumber,
  country,
}: {
  phoneNumber?: string | null
  country?: string | null
}): string | null {
  if (!phoneNumber) {
    return null
  }
  if (!country) {
    country = 'ZZ'
  }

  const phoneNumberUtil = PhoneNumberUtil.getInstance()
  try {
    const regionCode = Object.keys(COUNTRY_TO_REGIONS).includes(country)
      ? COUNTRY_TO_REGIONS[country]
      : country

    // Normalize 00 prefix to + prefix for international numbers
    const normalizedPhoneNumber = phoneNumber.startsWith('00')
      ? '+' + phoneNumber.substring(2)
      : phoneNumber

    const hasInternationalPrefix = normalizedPhoneNumber.startsWith('+')
    const cleanedPhoneNumber = normalizedPhoneNumber.replaceAll(/\D/g, '')

    let phone
    if (hasInternationalPrefix) {
      // When phone has + prefix, parse it directly to detect country from the country code
      phone = phoneNumberUtil.parse(normalizedPhoneNumber, undefined)
    } else {
      // No prefix, use the provided country as fallback
      phone = phoneNumberUtil.parseAndKeepRawInput(cleanedPhoneNumber, regionCode)
    }

    if (!phoneNumberUtil.isPossibleNumber(phone)) {
      return null
    }
    return phone.getCountryCode() + '' + phone.getNationalNumber()
  } catch {
    return null
  }
}
